import React, { useRef, useState, useEffect, useContext } from "react";
import MenuHeader from "./../MenuHeader";
import { ProductContext } from "../../../../store";
import { Spinner } from "reactstrap";
import Switch from "react-switch";

const Dynamic = ({type}) => {
	const [productCount, setProductCount] = useState(""); // Local state for input
	const [error, setError] = useState("");
	const [height, setHeight] = useState("100vh");
	const divRef = useRef(null);	
	const {
		products,
		enableDynamic,
		setEnableDynamic,
		trggierDynamic,
		saveLoader,
		setTriggerDynamic,
	} = useContext(ProductContext);

	useEffect(() => {
		const calculateHeight = () => {
			if (divRef.current) {
				const top = divRef.current.getBoundingClientRect().top;
				setHeight(`calc(100vh - ${top}px)`);
			}
		};
		calculateHeight();
		window.addEventListener("resize", calculateHeight);
		return () => window.removeEventListener("resize", calculateHeight);
	}, []);

	const isSaveButtonDisabled = !productCount || isNaN(Number(productCount)) || Number(productCount) <= 0;

	return (
		<>
			<MenuHeader title="AI Merchandising" />
			<div
				className="sideBarMenuGridContainer"
				ref={divRef}
				style={{ height, position: "relative" }}
			>
				<div className="menuContentWrapper" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
					<div className="d-flex flex-column p-4">
						<div className="d-flex gap-3 justify-content-between align-items-center mb-4">
							{products.length > 0 ? (
								<>
									<div>
										<h4 className="mb-2">Enable AI Merchandising</h4>
										<small>
											Turn on AI Merchandising to dynamically promote the products
										</small>
									</div>
									<div style={{ transform: "scale(0.8)", transformOrigin: "right center" }}>
										{saveLoader ?
											<Spinner size="sm" color='#ccc' />
										:
											<Switch
												checked={enableDynamic}
												onChange={() => {setEnableDynamic((prev) => !prev); setTriggerDynamic(true);}}
												onColor={"#9eb3fc"}
												onHandleColor={"#3c64f4"}
												handleDiameter={25}
												uncheckedIcon={false}
												checkedIcon={false}
												boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
												activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
												height={15}
												width={40}
												className="react-switch"
												id="material-switch"
											/>
										}
									</div>
								</>
							) : (
								<div className="emptyListMessageContainer">
									<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
										<g id="surface1">
											<path style={{ stroke: "none", fillRule: "nonzero", fill: "rgb(0%,0%,0%)", fillOpacity: 1 }} d="M17.68 2.01C15.55 0.29 12.76 -0.38 10.08 0.2 6.59 0.95 3.88 3.71 3.18 7.21c-0.64 3.14 0.44 6.38 2.83 8.5v0.04c0 1.18 0.56 2.28 1.5 2.98v1.52c0 1.24 1.01 2.25 2.25 2.25h0.53c0.13 0.85 0.86 1.5 1.72 1.5s1.59-0.65 1.72-1.5h0.53c1.24 0 2.25-1.01 2.25-2.25v-1.52c0.94-0.7 1.5-1.8 1.5-2.98v-0.04c1.91-1.71 3-4.15 2.99-6.71 0.01-2.72-1.21-5.28-3.32-6.99zM15 19.5v0.75c0 0.41-0.34 0.75-0.75 0.75h-4.5c-0.41 0-0.75-0.34-0.75-0.75V19.5zm1.77-4.71c-0.17 0.14-0.27 0.35-0.27 0.58v0.39c0 1.24-1.01 2.25-2.25 2.25h-4.5c-1.24 0-2.25-1.01-2.25-2.25v-0.39c0-0.23-0.1-0.44-0.27-0.58-2.15-1.76-3.14-4.57-2.56-7.28 0.58-2.91 2.83-5.17 5.74-5.83 0.52-0.11 1.05-0.17 1.59-0.17 1.73 0 3.4 0.59 4.74 1.67 1.76 1.42 2.78 3.57 2.77 5.82 0 2.24-1 4.34-2.73 5.71zM12.75 5.25c0 0.41-0.34 0.75-0.75 0.75-1.66 0-3 1.34-3 3 0 0.41-0.34 0.75-0.75 0.75S7.5 9.41 7.5 9c0-2.49 2.02-4.5 4.5-4.5 0.41 0 0.75 0.34 0.75 0.75z" />
										</g>
									</svg>
									<div>Hey There!</div>
									<div>
										AI Merchandising cannot be enabled without products. Please enter a valid search term or choose a category to proceed.
									</div>
									<div>Happy merchandising!</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Dynamic;